exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_settings_v4l1gVco0wUouKuRvFviS {\n  width: 100%;\n  float: left;\n  clear: both;\n  box-sizing: border-box;\n}\n\n.IA_settings_v4l1gVco0wUouKuRvFviS h3 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.IA_settings_error_message_21ATCv3XoEQ6VrI1r7ESGG {\n  color: red;\n  margin-top: 10px;\n}\n\n.IA_notification_toggle_text_2xXhtmxwzypBs3OeloY8ZK {\n  font-size: 12px;\n  color: gray;\n  display: inline-block;\n}", ""]);

// Exports
exports.locals = {
	"IA_settings": "IA_settings_v4l1gVco0wUouKuRvFviS",
	"IA_settings_error_message": "IA_settings_error_message_21ATCv3XoEQ6VrI1r7ESGG",
	"IA_notification_toggle_text": "IA_notification_toggle_text_2xXhtmxwzypBs3OeloY8ZK"
};